import React from 'react';
import PropTypes from 'prop-types';
import Link from 'shared/components/Link';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AgencyInfoSmall.css';

const AgencyInfoSmall = ({ src, link, title }) =>
  <div className={s.agency}>
    <Link to={link} className={s.agencyLink}>
      <span>
        <img src={src} width="30" className={s.agencyLogo} alt="" />
      </span>
      <span className={s.agencyTitle}>
        {title}
      </span>
    </Link>
  </div>;

AgencyInfoSmall.propTypes = {
  src: PropTypes.string,
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

AgencyInfoSmall.defaultProps = {
  src: '',
};

export default withStyles(s)(AgencyInfoSmall);



// WEBPACK FOOTER //
// ./src/desktop/components/AgencyInfoSmall/AgencyInfoSmall.js